var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTurnoff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73918 9.73801C10.0878 9.3891 10.0878 8.82341 9.73918 8.4745L6.26282 4.99497L9.72912 1.5255C10.0777 1.17659 10.0777 0.610897 9.72912 0.261988C9.38053 -0.0869208 8.81535 -0.0869214 8.46676 0.261987L5.00046 3.73146L1.53386 0.261681C1.18527 -0.0872273 0.62009 -0.087227 0.2715 0.261682C-0.0770901 0.61059 -0.0770906 1.17628 0.271499 1.52519L3.73811 4.99497L0.261442 8.47481C-0.0871477 8.82372 -0.0871474 9.38941 0.261443 9.73832C0.610033 10.0872 1.17521 10.0872 1.5238 9.73832L5.00046 6.25848L8.47682 9.73801C8.82541 10.0869 9.39059 10.0869 9.73918 9.73801Z",
    fill: "#1B130E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnoff);
export default __webpack_public_path__ + "static/media/turnoff.6908ffd2579a58ebbd8b51f0a1999add.svg";
export { ForwardRef as ReactComponent };